import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { PrincipalService } from '@app/principal/service/principal.service';
import { ButtonComponent } from '@app/shared/button/button.component';
import { SetupPasswordService } from '@modules/sign-in/components/sign-in/components/forgot-password-state/components/password-recovery-by-phone-number-state/setup-password.service';
import { map, Observable, tap } from 'rxjs';
import { TypeStep } from '../sign-up.component';

@Component({
  selector: 'app-create-new-password',
  templateUrl: './create-new-password.component.html',
  styleUrls: ['./create-new-password.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonComponent, ReactiveFormsModule],
})
export class CreateNewPasswordComponent implements OnInit {
  isShowPassword = false;
  isShowConfirmPassword = false;
  passForm: FormGroup;
  setupPasswordOperation$: Observable<void>;
  setupPasswordOperationInFly$: Observable<boolean>;
  @Input() login: string;
  @Input() token: string;

  @Output() closePassSetup = new EventEmitter<TypeStep>();
  constructor(
    private _setupPasswordService: SetupPasswordService,
    private _principalService: PrincipalService,
  ) {}

  ngOnInit(): void {
    this.passForm = new FormGroup(
      {
        password: new FormControl<string>(null, [Validators.required]),
        confirmPassword: new FormControl<string>(null, [Validators.required]),
      },
      { validators: this.checkPassword as ValidatorFn },
    );

    this.initSetupPassword();
  }

  checkPassword(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.get('password')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;

    return password === confirmPassword ? null : { passwordsMismatch: true };
  }

  initSetupPassword(): void {
    this.setupPasswordOperation$ = this._setupPasswordService.setupPassword$.pipe(
      tap((profile) => this._principalService.setCurrentUser(profile)),
      tap(() => this.closePassSetup.emit('closeAll')),
      map(() => void 0),
    );

    this.setupPasswordOperationInFly$ = this._setupPasswordService.setupPasswordOperationInFly$;
  }

  public setPassword(): void {
    this._setupPasswordService.setupPassword({ token: this.token, credentials: { login: this.login, password: this.passForm.get('password').value } });
  }
}
